import { tradeItemGroupKey } from "modules/tradeLists/utils/tradeItemGroupKey";

type TradeItemKeyShape = {
  ids: readonly string[];
};

export function tradeItemKey(item: TradeItemKeyShape): string {
  return tradeItemGroupKey(item.ids);
}
